export default function BiasModal({ onSelect }) {
  return (
    <div data-testid="bias-modal" className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-4">
      <div className="bg-[#151a24] border border-slate-800 rounded-2xl max-w-md w-full p-6 text-center shadow-2xl">
        <div className="w-16 h-16 bg-blue-600/10 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-4 border border-blue-500/20">
          <i className="fa-solid fa-chart-line text-2xl"/>
        </div>
        <h2 className="text-xl font-bold text-white mb-2">Establish Daily Narrative</h2>
        <p className="text-xs text-slate-400 mb-6">Algorithms deliver price toward higher-timeframe objectives. Define your directional bias before engaging the matrix.</p>
        <div className="space-y-3">
          <button data-testid="bias-bullish" onClick={() => onSelect("Bullish")}
            className="w-full py-3 px-4 bg-emerald-600/20 hover:bg-emerald-600/30 text-emerald-400 border border-emerald-500/30 rounded-xl font-semibold transition-all flex items-center justify-between">
            <span><i className="fa-solid fa-arrow-trend-up mr-2"/> Bullish Order Flow</span>
            <i className="fa-solid fa-chevron-right text-xs opacity-50"/>
          </button>
          <button data-testid="bias-bearish" onClick={() => onSelect("Bearish")}
            className="w-full py-3 px-4 bg-rose-600/20 hover:bg-rose-600/30 text-rose-400 border border-rose-500/30 rounded-xl font-semibold transition-all flex items-center justify-between">
            <span><i className="fa-solid fa-arrow-trend-down mr-2"/> Bearish Order Flow</span>
            <i className="fa-solid fa-chevron-right text-xs opacity-50"/>
          </button>
          <button data-testid="bias-consolidation" onClick={() => onSelect("Consolidation")}
            className="w-full py-3 px-4 bg-amber-600/20 hover:bg-amber-600/30 text-amber-400 border border-amber-500/30 rounded-xl font-semibold transition-all flex items-center justify-between">
            <span><i className="fa-solid fa-arrows-left-right mr-2"/> Equilibrium / Consolidation</span>
            <i className="fa-solid fa-chevron-right text-xs opacity-50"/>
          </button>
        </div>
      </div>
    </div>
  );
}
